const env = process.env.ENVIRONMENT || process.env.NEXT_PUBLIC_ENVIRONMENT

export const IS_PRODUCTION = env === 'production'

export const CARD_TOKEN_JS_URL = IS_PRODUCTION
  ? 'https://static.mul-pay.jp/ext/js/token.js'
  : 'https://stg.static.mul-pay.jp/ext/js/token.js'

export const RESERVATION_STATUS = {
  UPCOMING: 'upcoming',
  COMPLETED: 'done',
  CANCEL: 'cancelled',
  PAYMENT_PENDING: 'payment_pending',
}
export const ROOM_SIZE: { [key: string]: any } = {
  square_meters: 'm²',
  tatami_mats: 'tatami mats',
}

export const ROOM_GUEST_FIELD = 'roomGuests'

export const ADDITIONAL_QUESTIONS = {
  BOOK_FOR: 'Book for',
  BOOK_FOR_JP: '宿泊者情報',
  REMARK: 'Remark',
  REMARK_JP: '備考',
  REMARK_JP_PRD: 'ご要望などございましたら、ご記載下さいませ。',
  REMARK_KO: '자유롭게 질문을 설정하십시오',
  REMARK_CH_HANS: '可设定自由提问',
  REMARK_CH_HANT: '可設定自由提問',
  ESTIMATED_ARRIVAL_TIME: 'check-in',
}

export const BOOKING_FOR_OPTIONS = {
  MY_SELF: 'My Self',
  SOMEONE_ELSE: 'Someone else',
}

export const CLIENT_SESSION_KEY = 'tripla_client_session'

export const JA_LANGUAGE = 'ja'
export const DEFAULT_LANG = JA_LANGUAGE

export const TERM_OF_USE = 'https://tripla.io/membership-agreement/'
export const PRIVACY_POLICY = 'https://en.tripla.io/privacy-policy-2'
export const GDPR_POLICY = 'https://en.tripla.io/gdpr-privacy-policy/'
export const MEMBERSHIP_AGREEMENT = 'https://www.tokyustay.co.jp/clause/'
export const APP_TERMS_OF_USE = 'https://www.tokyustay.co.jp/clause/'
export const PRIVACY_POLICY_BY_THE_HOTEL =
  'https://www.tokyu-rs.co.jp/privacypolicy/'

export const APP_STORE_LINK =
  'https://apps.apple.com/us/app/tokyu-stay/id1613945562'
export const PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=com.tokyuapp'

export const OPEN_APP_LINK = 'https://tokyuapp.page.link/open-app'

export const STAGING_FIREBASE_DYNAMIC_LINK =
  'https://tokyuapp.page.link/staging-app'

export const INQUIRY_LONG_STAY_LINK =
  'https://www.tokyustay.co.jp/inquiry_longstay'

export const getPocketRDUrl = (locale: string, path = ''): string =>
  `${process.env.NEXT_PUBLIC_POCKETRD_UI_BASE_URL}/${locale}${path}`

export const RESALE_DETAILS_LINKS: Record<string, string> = {
  ja: 'https://www.tokyustay.co.jp/resale/',
  en: 'https://www.tokyustay.co.jp/en/resale',
  'zh-Hans': 'https://www.tokyustay.co.jp/chn_cn/resale',
  'zh-Hant': 'https://www.tokyustay.co.jp/chn_tc/resale',
  ko: 'https://www.tokyustay.co.jp/kor/resale',
}

export const DEVICE_NAMES = {
  ANDROID: 'Android',
  IOS: 'iOS',
  OTHERS: 'Others',
}

export const TEXT_KATAKANA_REGEX = /^[\u30A1-\u30FA\u30FC]+$/

export const FULL_WIDTH_NUMBER_REGEX = /[\uFF10-\uFF19]/

// Removed ー (U+30FC) to allow katakana prolonged sound mark in names
export const FULL_WIDTH_SPECIAL_CHARACTERS_REGEX =
  /[｀〜！＠＃＄％＾＆＊（）＝＿＋「」『』；'："、。・＜＞？￥¥×÷’”｜]/

export const STANDARD_ASCII_SPECIAL_CHARACTERS_REGEX =
  /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/

export const MAX_NIGHS_RESERVATION = 31

export const DEFAULT_AMENITIES_NAMES = {
  en: ['Washer＆Dryer', 'Mini Kitchen', 'Microwave', 'Non-smoking', 'Smoking'],
  ja: ['洗濯乾燥機', 'ミニキッチン', '電子レンジ', '禁煙', '喫煙'],
  ko: ['세탁 건조기', '미니주방', '전자 레인지', '금연', '흡연'],
  'zh-Hans': ['洗衣烘衣机', '迷你厨房', '微波炉', '禁烟', '吸烟'],
  'zh-Hant': ['洗衣烘衣機', '迷你廚房', '微波爐', '禁菸', '吸菸'],
}

export const PAYMENT_TYPE = {
  CREDIT_CARD: 'credit_card',
  ON_SITE: 'on_site',
}

// Currently these max retry are used for refresh token
export const TRIPLA_REQUEST_MAX_RETRY = 4
export const SMARTCLUB_REQUEST_MAX_RETRY = 4
// Max retry for query mutation
export const QUERY_MUTATION_MAX_RETRY = 5

export const SMARTCLUB_DEFAULT_HOTEL_PLAN_NAME = 'standard'

export const TRIPLA_CHECKIN_CHECKOUT_DATE_FORMAT = 'YYYY/MM/DD'

export const DEFAULT_DELAY = 3000 // 3 seconds
export const DEFAULT_MAX_DELAY = 10000 // 10 seconds

export const TRIPLA_CREATE_RESERVATION_NETWORK_ERR_MSG =
  'Tripla Create Reservation Error Network Issue'

export const TRIPLA_UPDATE_RESERVATION_NETWORK_ERR_MSG =
  'Tripla Update Reservation Error Network Issue'

export const TRIPLA_ERROR_CODES = {
  PRE_3D_SECURE_TRANSACTION_EXIST: '3013',
}

export const BOOKED_SUCCESSFUL_COOKIE_NAME = 'booked-successful'

export const SMARTCLUB_RESERVATION_VALIDATION_ERROR_FIELD: Record<
  string,
  string
> = {
  email: 'Email is invalid',
}

export const CREDIT_CARD_BRANDS = [
  {
    label: 'VISA',
    value: 'visa',
    imageSrc: '/images/cards/visa.png',
  },
  {
    label: 'Mastercard',
    value: 'master-card',
    imageSrc: '/images/cards/master-card.png',
  },
  {
    label: 'American Express',
    value: 'amex',
    imageSrc: '/images/cards/ac-card.png',
  },
  {
    label: 'JCB',
    value: 'jcb',
    imageSrc: '/images/cards/jcb.png',
  },
  {
    label: 'Diners',
    value: 'dinersclub',
    imageSrc: '/images/cards/dinner-club.png',
  },
]

export const BOOKING_WIDGET_PAYMENT_SETTING = {
  'GMO-PAYPAL': 'gmo-paypal',
  GMO: 'gmo',
}

// Hanare Hotel Config
// note: for STG we use Shimbashi for test
export const HANARE_HOTEL_CONFIG = {
  hotelCode:
    env === 'production' ? '0196f694-cf23-7e88-a752-0b96c6fc45a6' : null,
  id: env === 'production' ? 7142 : null,
  cutoffDate: '2025-09-29',
  checkinDate: '2025-09-29',
  adults: 2,
  rooms: 1,
}

export const EBISU_HOTEL_CONFIG = {
  hotelCode:
    env === 'production'
      ? '0199516a-0c67-7a5c-b9e6-65756967c670'
      : 'c5f8adfd-4fe4-4246-9464-e44de19b1dd7',
  id: env === 'production' ? 7674 : 2036,
  cutoffDate: '2026-03-17',
  checkinDate: '2026-03-17',
}

export const MERCURE_HIROSHIMA_HOTEL_CONFIG = {
  hotelCode:
    env === 'production'
      ? '0198e5c7-8361-7506-b0d0-f11ffd81a7fc'
      : '24646773533ad4b699db0940665c99a0',
  id: env === 'production' ? 7555 : 262,
  cutoffDate: '2026-05-18',
  checkinDate: '2026-05-18',
}

// Shinjuku Opening Hotel Config - opens 2026-09-29
// TODO: fill in hotelCode and id once assigned
export const SHINJUKU_OPENING_HOTEL_CONFIG = {
  hotelCode:
    env === 'production'
      ? 'ee356759050c18b2a251b859713a8e18'
      : '92b5e7db-c12f-4318-a681-d2db41c89c9b',
  id: env === 'production' ? 2777 : 2049,
  cutoffDate: '2026-09-18',
  checkinDate: '2026-09-18',
}

// Tripla chatbot — enabled per hotel, each hotel has its own bot code.
// Tripla only issues production bot codes (no staging bots exist), so the same
// botCode is used in both environments; only the hotelCode differs per env.
// An empty hotelCode or botCode keeps the chatbot off for that hotel.
export const CHATBOT_HOTELS = [
  {
    // Tokyu Stay Hakodate Asaichi Akari no Yu
    hotelCode:
      env === 'production'
        ? '96eddbf21f9513b9cd91ca04a60da74e'
        : 'c6dd4df4-d75d-4076-ad6e-f85f977c5613',
    botCode: '96eddbf21f9513b9cd91ca04a60da74e',
  },
  {
    // Tokyu Stay Sapporo
    hotelCode:
      env === 'production'
        ? '30c1177bf9496b93e28d74c518d8af75'
        : 'b1becfa1-544b-4146-a42f-7cc4b1e1a5a1',
    botCode: '30c1177bf9496b93e28d74c518d8af75',
  },
  {
    // Tokyu Stay Kamata
    hotelCode:
      env === 'production'
        ? '74baeb6baf0be15503204290ab69d560'
        : '75228eee-1728-4432-9cd1-57427193af0e',
    botCode: '74baeb6baf0be15503204290ab69d560',
  },
]

// Shinjuku Hotel Closure Notice Config
export const SHINJUKU_CLOSURE_HOTEL_CONFIG = {
  hotelCode:
    env === 'production'
      ? 'ee356759050c18b2a251b859713a8e18'
      : '92b5e7db-c12f-4318-a681-d2db41c89c9b',
}

export const NISHI_SHINJUKU_HOTEL_CONFIG = {
  hotelCode:
    env === 'production'
      ? '10fd5145be14fd810e74cb186f2aa72e'
      : 'e66af49b-d8b1-4dde-a56b-0adf3443561f',
}

export const SHINJUKU_EAST_SIDE_HOTEL_CONFIG = {
  hotelCode:
    env === 'production'
      ? 'd5a72e0a78ccfd1d25cb9e2b97cfc995'
      : 'ec11747d-0976-4c7d-8be0-948898be74f7',
}

// Gotanda Hotel Closure Notice Config
export const GOTANDA_CLOSURE_HOTEL_CONFIG = {
  hotelCode:
    env === 'production'
      ? 'ed543cbcd1df8f3fe2cce0d5a92fe29f'
      : '42e7ff98-493f-4f4a-8658-509fdd5f862c',
}

// Gotanda Reopening Hotel Config - reopens 2027-04-01
// Same hotel as GOTANDA_CLOSURE_HOTEL_CONFIG; kept separate to mirror the
// Shinjuku closure/opening split.
export const GOTANDA_OPENING_HOTEL_CONFIG = {
  hotelCode:
    env === 'production'
      ? 'ed543cbcd1df8f3fe2cce0d5a92fe29f'
      : '42e7ff98-493f-4f4a-8658-509fdd5f862c',
  cutoffDate: '2027-03-17',
  checkinDate: '2027-03-17',
}

// NFT Configuration
export const NFT_IDENTIFIER = 'NFT'

export const NFT_PLAN_ID = env === 'production' ? 14031 : 4841

export const POCKET_RD_ALIAS_EMAIL =
  env === 'production' ? 'stay@tqwallet.io' : 'stg-stay@tqwallet.io'

export const DEFAULT_ROOM_GUEST_INDEX_VALUE = 1
export const DEFAULT_ROOM_GUEST_NUMBER_OF_ADULT = 1
export const DEFAULT_ROOM_GUEST_NUMBER_OF_CHILDREN = 0

export const DEFAULT_ROOM_GUEST_VALUE = [
  {
    index: DEFAULT_ROOM_GUEST_INDEX_VALUE,
    numberOfAdult: DEFAULT_ROOM_GUEST_NUMBER_OF_ADULT,
    numberOfChildren: DEFAULT_ROOM_GUEST_NUMBER_OF_CHILDREN,
  },
]

export enum RESERVATION_MODE_ENUM {
  STANDARD = 'standard',
  SECRET = 'secret',
}

export const RESERVATION_MODE = {
  STANDARD: 'standard' as RESERVATION_MODE_ENUM.STANDARD,
  SECRET: 'secret' as RESERVATION_MODE_ENUM.SECRET,
}
